import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Image, Row,Spinner } from "react-bootstrap";
import BreadcrumbSection from "components/BreadcrumbSection";
import IMAGES from "constants/images";
import { Link, useNavigate } from "react-router-dom";
import VendorSidebar from "inc/VendorSidebar";
import { Icon } from "@iconify/react";
import { getNotificationList } from "api/ActivityService";
import { Sentry } from "react-activity";
const notifications = [
  {
    id: 1,
    title: "Review Submission",
    message:
      "Your review for Slack has been submitted and is under moderation.",
    time: "2 hrs ago",
    icon: IMAGES.Notifications_IMG1,
  },
  {
    id: 2,
    title: "New Review Submitted by Robert William!",
    message: "Robert William has just submitted a new review.",
    time: "2 hrs ago",
    icon: IMAGES.Notifications_IMG2,
    actionText: "Check it out!",
  },
  {
    id: 3,
    title: "Review Update",
    message: "You’ve successfully updated your review for ClickUp.",
    time: "2 hrs ago",
    icon: IMAGES.Notifications_IMG3,
  },
  {
    id: 4,
    title: "Password Change",
    message:
      "Your password was changed successfully. If this wasn’t you, contact support immediately.",
    time: "Jan 18, 2025",
    icon: IMAGES.Notifications_IMG4,
  },
  {
    id: 5,
    title: "Welcome to Xuthority!",
    message:
      "Welcome to Xuthority! Start exploring and sharing your reviews today.",
    time: "Jan 05, 2025",
    icon: IMAGES.Notifications_IMG5,
  },
  {
    id: 6,
    title: "New Badge Approved!",
    message:
      "Congratulations! You’ve earned the new badge for your contributions.",
    time: "Jan 04, 2025",
    icon: IMAGES.Badgecolor1_IMG,
  },
];

const NotificationCard = ({ title, message, actionText, createdAt,type,linkUrl }) => {
  const getIcon = (type) => {
    if(type==='reviews' || type==='comments'){
      return IMAGES.Reviews_IMG;
    }
    if(type==='disputes'){
      return IMAGES.Notifications_IMG;
    }
    if(type==='badges'){
      return IMAGES.Badge_IMG;
    }
    if(type==='follow'){
      return IMAGES.Followers_IMG;
    }
    if(type==='verified' || type==='password'){
      return IMAGES.Approved_IMG;
    }
    if(type==='welcome'){
      return IMAGES.Welcome_IMG;
    }
    return IMAGES.Notifications_IMG;
  }
  return (
    <Card className="mb-3 notification-card">
      <Card.Body>
        <Row className="align-items-start">
          <Col className="d-flex">
            <Image
              className="notification_icon me-3 flex-shrink-0"
              src={getIcon(type)}
              alt=""
            />
  
            <div className="d-flex justify-content-between flex-wrap " style={{ width: '100%' }}>
              <Card.Title className="d-flex justify-content-between " style={{ width: '100%' }}>{title}
  
                <small className="text-muted">{new Date(createdAt).toLocaleDateString()}</small>
  
              </Card.Title>
              <Card.Text className="text-muted mb-1">
                {message}{" "}
                {/* {actionText && (
                  <Link className="text-primary fw-semibold" to={linkUrl}>
                    {actionText}
                  </Link>
                )} */}
              </Card.Text>
            </div>
  
  
          </Col>
  
        </Row>
  
  
      </Card.Body>
    </Card>
  )
}

const Notifications = () => {
  const [showFollowers, setShowFollowers] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(true);
  const fetchNotifications = async (pg = 1) => {
    setLoading(true);
    try {
      const res = await getNotificationList(pg, 4);
      if (res.success) {
        setNotifications(pg === 1 ? res.body.data : [...notifications, ...res.body.data]);
        setTotalPages(res.body.total_pages);
      }
    } finally {
      setLoading(false);
      setPageLoading(false)
    }
  };


  useEffect(() => {
    fetchNotifications();
  }, []);

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchNotifications(nextPage);
  };
  if(pageLoading){
    return (
      <div className="loaderdiv">
        <Sentry color="#e91515" size={40} speed={1} animating={true} />
      </div>
    )
  }
  return (
    <Col lg={12} xl={12}>
      <div className="right_profile_style">
        <div className="tab_1_style">
          <div className="software_header mb-4 d-flex justify-content-between align-items-center">
            <div className="profile_details_style header_profile3">
              <h3 className="mb-0">Notifications</h3>
            </div>
            <div className="profile_details_style  header_profile2  d-flex  justify-content-between ">
              <div className="d-flex align-items-center">
                <Icon
                  icon="mdi:arrow-left"
                  style={{ fontSize: "24px" }}
                  className="me-4"
                  onClick={() => navigate("/vendor/my-profile")}
                />
                <h3 className="mb-0">Notifications</h3>
              </div>
            </div>

            <Link className="fw-normal ms-auto me-3">Mark All Read</Link>
          </div>
          {notifications.length > 0 ? notifications.map((notif) => (
            <NotificationCard key={notif._id} {...notif}  actionText={notif.type==='reviews' ? 'Check Now!' : ''} linkUrl={notif.type==='reviews' ? `/vendor/reviews/${notif.reviewId}` : '#'} />
          )): (
            <Col xs={12}>
            <div className="text-center py-5">
              <Image
                src={IMAGES.emptyState}
                alt=""
                   height="300px"
                width= "300px"
                className="mb-4"
                // className="imgUser"
              />
           <div className="text-center py-5 text-muted">No notifications found.</div>
           </div>
           </Col>
         )}

{page < totalPages && (
          <div className="text-center mt-4">
            <Button onClick={handleLoadMore} disabled={loading} variant="link">
              {loading ? <Spinner animation="border" size="sm" /> : "Load More"}
            </Button>
          </div>
        )}
        </div>
      </div>
    </Col>
  );
};

export default Notifications;
